import { FC, useState } from 'react';

import type { TranscriptorConsultation } from '@/entities/transcriptor';

import { useCanEditTemplates } from '../hooks';
import { isFieldListDocument } from '../lib';

import { DocumentTabs } from './DocumentTabs';
import { OpenTemplateButton } from './EditTemplateButton';
import { TemplatePreview } from './TemplatePreview';

type Props = {
  encounter: TranscriptorConsultation;
  className?: string;
};

// The summary and the evaluation of a consultation being recorded, as the
// fields AI writes after Stop, from the versions the recording pinned with
// the titles and instructions set for it before the start.
export const LiveConsultationDocuments: FC<Props> = ({
  encounter,
  className,
}) => {
  const [documentKey, setDocumentKey] = useState('');
  const canEditTemplates = useCanEditTemplates();
  const documents = encounter.documents.filter(isFieldListDocument);
  const shown =
    documents.find((document) => document.id === documentKey) ?? documents[0];
  const seriesId = shown?.template_series_id;

  if (!shown?.id || !shown.template_id) {
    return null;
  }
  return (
    <DocumentTabs
      className={className}
      tabs={documents.map((document) => ({
        key: document.id ?? '',
        label: document.tab_title || document.name || document.code || '',
        included: true,
      }))}
      activeKey={shown.id}
      disabled={false}
      onChange={setDocumentKey}
    >
      <TemplatePreview
        key={shown.template_id}
        templateId={shown.template_id}
        fieldList={{
          actions: canEditTemplates && seriesId && (
            <OpenTemplateButton seriesId={seriesId} />
          ),
          sectionOverrides: shown.section_overrides,
        }}
      />
    </DocumentTabs>
  );
};
